import { hbs } from 'ember-cli-htmlbars';
export default hbs("<g\n  class=\'chart-grid\'\n  data-test-chart-grid\n  ...attributes\n  {{did-insert this.renderD3Grid}}\n>\n  {{#if this.container}}\n    {{this.d3Grid}}\n  {{/if}}\n</g>")